import { useEffect } from 'react';

const SITE_NAME = 'AOK Communications';
const DEFAULT_DESCRIPTION =
  'AOK Communications – Empowering communication through public speaking and digital strategy.';

function setMetaTag(name, content) {
  if (!content) return;
  let tag = document.querySelector(`meta[name="${name}"]`);
  if (!tag) {
    tag = document.createElement('meta');
    tag.setAttribute('name', name);
    document.head.appendChild(tag);
  }
  tag.setAttribute('content', content);
}

/**
 * Sets the document title and meta description per page.
 * Falls back to the site defaults when unmounted so shared crawlers/tabs
 * never see a stale page-specific title.
 */
function Seo({ title, description }) {
  useEffect(() => {
    const fullTitle = title ? `${title} | ${SITE_NAME}` : SITE_NAME;
    document.title = fullTitle;
    setMetaTag('description', description || DEFAULT_DESCRIPTION);

    return () => {
      document.title = SITE_NAME;
      setMetaTag('description', DEFAULT_DESCRIPTION);
    };
  }, [title, description]);

  return null;
}

export default Seo;
